import { PartOfDay } from '../time-off-part-of-day';
import { ApprovalStepStatus, TimeOffRequestAllowedAction } from '../time-off-request';
import { TimeOffStatus } from '../time-off-status';
import { TimeOffTimeCategory } from '../time-off-time-category';

export enum DayPortion {
  Full = 'FULL',
  Half = 'HALF',
  Quarter = 'QUARTER',
  Hourly = 'HOURLY',
}

export enum ApprovalStatusDto {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'DECLINED',
}

export interface TimeOffRequestDayResponse {
  date: string;
  portion: DayPortion;
  dayPartNumber: number | null;
  /** Minutes off for the day — only populated for HOURLY portions; null otherwise. */
  minutes: number | null;
  partOfDay: PartOfDay;
}

export interface OpsiumUserShortResponse {
  id: number;
  name: string;
  email: string | null;
  isDeleted: boolean;
  profileImageUrl: string | null;
}

export interface TimeOffRequestApproverResponse {
  user: OpsiumUserShortResponse;
  status: ApprovalStatusDto;
  stepStatus: ApprovalStepStatus;
  decidedAt: string | null;
  comment: string | null;
}

export interface TimeOffTypeResponse {
  id: number;
  code: string | null;
  displayName: string;
}

export interface TimeOffRequestListItemResponse {
  id: number;
  type: TimeOffTypeResponse;
  status: TimeOffStatus;
  startDate: string;
  endDate: string;
  totalDays: number;
  days: TimeOffRequestDayResponse[];
  partOfDay: PartOfDay;
  approvers: TimeOffRequestApproverResponse[];
  requestedBy: OpsiumUserShortResponse;
  timeCategory: TimeOffTimeCategory;
  description: string | null;
  allowedActions: TimeOffRequestAllowedAction[];
  requestedAt: string;
  approvedAt: string | null;
}
